import { render, staticRenderFns } from "./indexOrdos.vue?vue&type=template&id=ed0481d6&scoped=true"
import script from "./indexOrdos.vue?vue&type=script&lang=js"
export * from "./indexOrdos.vue?vue&type=script&lang=js"
import style0 from "./indexOrdos.vue?vue&type=style&index=0&id=ed0481d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0481d6",
  null
  
)

export default component.exports